define('BookingEngine/app-BEBasket/module',['./settings', 'moment'], function (settings, moment) {
    return {

        createHtmlElement: function (priceItem, setBold) {
            var divItem = document.createElement("div"),
                priceSpan = document.createElement("span"),
                textSpan = document.createElement("span");

            if (setBold)
                textSpan.setAttribute("style", "font-weight: bold;");

            priceSpan.textContent = priceItem.priceString;
            textSpan.appendChild(priceSpan);
            var textNode = document.createTextNode(priceItem.text);
            textSpan.appendChild(textNode);
            divItem.appendChild(textSpan);
            return divItem;
        },

        createTotalAndDepositItems: function (priceItems) {
            var $thisModule = this,
                outerDiv = document.createElement("div");

            var total = priceItems.filter(function (e) {
                return e.text.toLowerCase() === ("total price");
            })

            outerDiv.appendChild($thisModule.createHtmlElement(total[0], true));

            var deposit = priceItems.filter(function (e) {
                return e.text.toLowerCase() === ("deposit");
            })

            if (deposit.length > 0)
                outerDiv.appendChild($thisModule.createHtmlElement(deposit[0]));

            return outerDiv;
        },

        createPriceItemList: function (priceItems) {
            var $thisModule = this,
                outerDiv = document.createElement("div");          

            var items = priceItems.filter(function (e) {
                return e.text.toLowerCase() !== "total price" && e.text.toLowerCase() !== ("deposit");
            });

            items.forEach(function (e) {
                outerDiv.appendChild($thisModule.createHtmlElement(e));
            })

            return outerDiv;
        },

        createCabinDetails: function (details) {
            var container = $("#cabinDetails");
            container.empty();
            if (!details)
                return;
            paragraph = $("<p>").attr("class", "mb-0");
            paragraph.append($("<span>").attr("style", "font-weight: 700").text("Cabin Details "));
            paragraph.append($("<span>").text(details));
            container.append(paragraph);
        },

        updateBasket: function () {
            var $thisModule = this;
            // hide the Email Quote button, the later code will show as appropriate
            $("#saveQuote").hide();

            var request = $.ajax({
                url: settings.basketUrl,
                type: "GET",
                cache: false,
                async: true,
                dataType: "json"
            });

            request.done(function (result) {
                $("#spnGuest").text(result.noofPassengers);
                $("#spnDuration").text(result.duration);
                $("#spnbb").text(result.boardBasis);
                $("#spndd").text(result.departureDate);
                $("#spnOccupancy").html(result.occupancyTypeDescription);
                $("#spnRoomDescription").html(result.roomDescription);
                $thisModule.createCabinDetails(result.cabinDetails);

                if (result.noofPassengers) {
                    $("#spnGuestContainer").show().closest('.section').show();
                };

                if (result.duration) {
                    $("#spnDurationContainer").show().closest('.section').show();
                };

                if (result.boardBasis) {
                    $("#pbb").show().closest('.section').show();
                };

                if (result.departureDate) {
                    $("#pdepartureDate").show().closest('.section').show();
                };

                if (result.occupancyTypeDescription) {
                    $("#proomContainer").show();
                };

                if (result.cabinDetails) {
                    $("#cabinDetails").show();
                    $("#proomContainer").hide();
                };

                if (result.outboundCarrierInfoValue != null) {
                    var str = "";

                    if (result.outboundCarrierInfoValue.length > 0) {
                        if (!$('body').hasClass('cruise-product')) {
                           str = "<p><strong>Outbound Flight</strong><br/>";
                        }
                        else {
                            str = "<p><strong>Outbound Journey</strong><br/>";
                       }
                    }

                    for (var i = 0; i < result.outboundCarrierInfoValue.length; i++) {
                        var departureDateTime = result.outboundCarrierInfoValue[i].departureDateTime;
                        departureDateTime = (moment(departureDateTime));
                        departureDateTime = departureDateTime.format("D MMM YYYY HH:mm");

                        var arrivalDateTime = result.outboundCarrierInfoValue[i].arrivalDateTime;
                        arrivalDateTime = moment(arrivalDateTime);
                        arrivalDateTime = arrivalDateTime.format("D MMM YYYY HH:mm");

                        var departurepport = result.outboundCarrierInfoValue[i].departurePort,
                            destionationport = result.outboundCarrierInfoValue[i].destinationPort;

                        str += departurepport + " to " + destionationport + "<br/>" +
                             "Depart - " + departureDateTime + "<br/>  " +
                             "Arrive - " + arrivalDateTime + "<br/>  " +
                            "</p>";
                    };

                    $("#outboundDiv").html(str).closest('.section').show();
                };

                if (result.inboundCarrierInfoValue != null) {
                    var inbstr = "";

                    if (result.inboundCarrierInfoValue.length > 0) {
                        if (!$('body').hasClass('cruise-product')) {
                            inbstr = "<p><strong>Return Flight</strong><br/>";
                        }
                        else {
                            inbstr = "<p><strong>Return Journey</strong><br/>";
                        }
                    }

                    for (var i = 0; i < result.inboundCarrierInfoValue.length; i++) {
                        var inbdepartureDateTime = result.inboundCarrierInfoValue[i].departureDateTime;
                        inbdepartureDateTime = (moment(inbdepartureDateTime));
                        inbdepartureDateTime = inbdepartureDateTime.format("D MMM YYYY HH:mm");

                        var inbarrivalDateTime = result.inboundCarrierInfoValue[i].arrivalDateTime;
                        inbarrivalDateTime = (moment(inbarrivalDateTime));
                        inbarrivalDateTime = inbarrivalDateTime.format("D MMM YYYY HH:mm");

                        var inbdeparturepport = result.inboundCarrierInfoValue[i].departurePort,
                            inbdestionationport = result.inboundCarrierInfoValue[i].destinationPort;

                        inbstr += inbdeparturepport + " to " + inbdestionationport + "<br/>" +
                            "Depart - " + inbdepartureDateTime + "<br/>  " +
                            "Arrive - " + inbarrivalDateTime + "<br/>  " +
                           "</p>";
                    };

                    $("#inboundDiv").html(inbstr).closest('.section').show();
                };

                if (result.priceItems && result.priceItems.length > 0) {
                    $("#saveQuote").show();
                    $("#priceItems").empty();
                    $("#priceItems").append($thisModule.createPriceItemList(result.priceItems));
                    $("#priceItems").append($thisModule.createTotalAndDepositItems(result.priceItems));
                };
            });
        }
    };
});
